import React from "react";
import { Link } from "react-router-dom";

export default function ProjectNotFound({ message = "Project not found !" }) {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "#191718",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <h2 style={{fontSize:"2rem",color:"#FFFFFF",textAlign:"center"}} >{message} 🥲</h2>
      <Link to="/" style={{fontSize:"1.5rem",color:"#FFFFFF",textAlign:"center",marginTop:"1rem"}}>
        Back to Home
      </Link>
    </div>
  );
}
